import styled from "styled-components";
import theme from './../theme';

const ContenedorFiltros = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.87rem; /* 30px */
 
    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;
 
        & > * {
            width: 100%;
            margin-bottom: 0.62rem; /* 10px */
        }
    }
`;

const ContenedorDayPicker = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    width: 40%;
    height: 5rem;

    @media screen and (max-width: 66rem) {
        .dialog-sheet {
            top: 250px !important;
        }
    }

    @media(max-width: 60rem){ /* 950px */
        width: 100%;
        flex-wrap: nowrap;
 
        & > * {
            // width: 100%;
            // margin-bottom: 0.62rem; /* 10px */
            display: inline-block;
        }

        .input-daypicker {
            width: 85%;
        }

        .dialog-sheet {
            top: 300px !important;
        }
    }
`;

const ContenedorFecha = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1.87rem; /* 30px */

    @media(max-width: 60rem){ /* 950px */
        flex-direction: column;

        & > * {
            width: 100%;
            margin-bottom: 0.62rem; /* 10px */
        }
    }
`;

const Titulo = styled.h1`
    font-weight: 400;
    font-family: sans-seriff;
    text-transform: uppercase;
    font-size: 2.5rem; /* 40px */
    text-align: center;

    @media(max-width: 60rem){ /* 950px */
        font-size: 2rem; /* 32px */
    }
`;
 
const Formulario = styled.form`
    padding: 0 2.5rem; /* 40px */
 
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    input {
        width: 100%;
        text-align: center;
        padding: 2.5rem 0;
        font-family: 'Work Sans', sans-serif;
        &::placeholder {
            color: rgba(0, 0, 0, 0.2);
        }
    }
 
    @media(max-width: 60rem){ /* 950px */
        justify-content: start;
    }
`;
 
const Input = styled.input`
    font-size: 1.5rem;
    border: none;
    border-bottom: 2px solid ${ theme.grisClaro } !important;
    outline: none;
 
    @media(max-width: 60rem){ /* 950px */
        font-size: 1.5rem; /* 24px */
    }

    color: rgba(0, 203, 94, 0.9);
`;
 
const InputGrande = styled(Input)`
    font-size: 4.37rem; /* 70px */
    font-weight: bold;
`;
 
const ContenedorBoton = styled.div`
    display: flex;
    justify-content: center;
    margin: 2.5rem 0;  /* 40px */
`;

export { ContenedorFiltros, Formulario, Input, InputGrande, ContenedorBoton, Titulo, ContenedorFecha, ContenedorDayPicker };